import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ContactUsFromDataType, FaqData, ResponseData } from "./common"

// API for get FAQ list
export interface FaqResponse extends AxiosResponse {
  data: FaqData[]
}
export function getFaqs(axiosInstance: AxiosInstance): Promise<FaqResponse> {
  const url = `/faq`
  return axiosInstance({
    method: "GET",
    url,
  }) as Promise<FaqResponse>
}

export interface FaqsLocaleBasedRequest extends Partial<AxiosRequestConfig> {
  params: {
    locale: string
  }
}
// API for get FAQ list
export function getFaqsLocaleBasedApi(
  { params }: FaqsLocaleBasedRequest,
  axiosInstance: AxiosInstance,
): Promise<FaqResponse> {
  const url = `/faq/web/${params.locale}`
  return axiosInstance({
    method: "GET",
    url,
  }) as Promise<FaqResponse>
}

// -----------------------------------------------------------------------------

// API for submit contact us form data
export interface ContactUsFromRequest extends Partial<AxiosRequestConfig> {
  params: ContactUsFromDataType
}

export function SubmitContactUsFrom(
  { params }: ContactUsFromRequest,
  axiosInstance: AxiosInstance,
) {
  const url = `https://api.kustomerapp.com/v1/hooks/form/623c6f4c890130cdacd4c6ca/89b4b3e1ad43cb2e7b9158434b0d23e5f56be0d5bbfbb9b27f52ee2a13fe29ce`
  return axiosInstance({
    method: "POST",
    url,
    data: params,
  })
}
// -----------------------------------------------------------------------------

// API for send verify Email
export interface SendVerifyEmailResponseData extends AxiosResponse {
  message: string
  status: number
}
export interface SendVerifyEmailResponse extends AxiosResponse {
  data: SendVerifyEmailResponseData
}
export function sendVerifyEmailApi(
  axiosInstance: AxiosInstance,
): Promise<SendVerifyEmailResponse> {
  const url = "/user/send-verify-email"
  return axiosInstance({
    method: "get",
    url,
    data: { isAuthTokenCheck: true },
  }) as Promise<SendVerifyEmailResponse>
}

// -----------------------------------------------------------------------------
export interface VerifyEmailRequest extends Partial<AxiosRequestConfig> {
  params: {
    token: string
  }
}

export interface VerifyEmailResponseData extends ResponseData {
  data: {
    email: string
    errorCode: number | string | null
    message: string
    status: number
    userId: number
    verified: boolean
    newUser: boolean
    promoCodeName: null | string
    promoCodeValue: string | null
  }
}
export interface VerifyEmailResponse extends AxiosResponse {
  data: VerifyEmailResponseData
}

export function verifyEmailAddressApi(
  {
    params,
    method = "put",
    url = `/user/${params.token}/verify/email`,
    ...config
  }: VerifyEmailRequest,
  axiosInstance: AxiosInstance,
): Promise<VerifyEmailResponse> {
  return axiosInstance({
    data: { ...params, avoidClientSideAuth: true },
    method,
    url,
    ...config,
  }) as Promise<VerifyEmailResponse>
}
